import { ChevronDown } from "lucide-react";
import PhoneMockup from "@/components/PhoneMockup";
import StoreBadges from "@/components/StoreBadges";

const Hero = () => (
  <section data-testid="hero-section" className="relative overflow-hidden pt-16">
    <div className="pointer-events-none absolute -top-40 right-[-10%] h-[560px] w-[560px] rounded-full bg-gradient-to-br from-brand to-navy opacity-25 blur-[120px]" />
    <div className="pointer-events-none absolute bottom-[-20%] left-[-10%] h-[400px] w-[400px] rounded-full bg-navy opacity-40 blur-[100px]" />

    <div className="relative mx-auto grid max-w-6xl items-center gap-16 px-4 pb-24 pt-16 sm:px-6 lg:grid-cols-2 lg:pt-24">
      <div>
        <span data-testid="hero-badge" className="inline-block rounded-full bg-brand-tint px-4 py-1.5 font-display text-xs font-semibold uppercase tracking-widest text-brand-tinttext">
          Snap. Price. Sell.
        </span>
        <h1 data-testid="hero-headline" className="mt-6 font-display text-4xl font-bold uppercase leading-[1.05] tracking-wide text-onsurface text-balance sm:text-5xl lg:text-6xl">
          Turn a photo into a ready-to-post listing in seconds
        </h1>
        <p data-testid="hero-subline" className="mt-6 max-w-lg text-base text-onsurface2 md:text-lg">
          AI-powered item identification, pricing and listing creation. From camera roll to eBay, Facebook or Gumtree in about 30 seconds.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <StoreBadges testIdPrefix="hero" />
          <a
            data-testid="hero-how-it-works-btn"
            href="#how-it-works"
            className="inline-flex items-center gap-2 rounded-lg border border-linestrong px-8 py-4 font-display text-base font-bold uppercase tracking-wider text-onsurface transition-colors duration-200 hover:border-brand-light hover:text-brand-light"
          >
            How it works <ChevronDown className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="relative">
        <PhoneMockup testId="hero-phone-mockup" />
      </div>
    </div>
  </section>
);

export default Hero;
